'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InfoModal = exports.CLASS_MODAL_OPEN = exports.INFO_MODAL_CLOSE = exports.INFO_MODAL_LINK = exports.INFO_MODAL_CONTENT = exports.INFO_MODAL_CONTAINER = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var INFO_MODAL_CONTAINER = exports.INFO_MODAL_CONTAINER = '[data-info-modal-container]'; /*
                                                                                          *  Information Modal
                                                                                          *    Scripts for reusable info modal objects
                                                                                          *
                                                                                          *  Version:
                                                                                          *    1.0.0 - 2020/07/29
                                                                                          */

var INFO_MODAL_CONTENT = exports.INFO_MODAL_CONTENT = '[data-info-modal-content]';
var INFO_MODAL_LINK = exports.INFO_MODAL_LINK = '[data-info-modal-link]';
var INFO_MODAL_CLOSE = exports.INFO_MODAL_CLOSE = '[data-info-modal-close]';

var CLASS_MODAL_OPEN = exports.CLASS_MODAL_OPEN = 'is-modal-open';

var InfoModal = exports.InfoModal = function () {
  function InfoModal(container) {
    var _this = this;

    (0, _classCallCheck3.default)(this, InfoModal);

    this.container = container;

    this.content = container.find(INFO_MODAL_CONTENT);

    container.on('click touchend', INFO_MODAL_LINK, function (e) {
      return _this.onLinkClick(e);
    });
    container.on('click touchend', INFO_MODAL_CLOSE, function (e) {
      return _this.onCloseClick(e);
    });
  }

  (0, _createClass3.default)(InfoModal, [{
    key: 'onCloseClick',
    value: function onCloseClick(e) {
      e.preventDefault();
      e.stopPropagation();

      this.content.removeClass(CLASS_MODAL_OPEN);
    }
  }, {
    key: 'onLinkClick',
    value: function onLinkClick(e) {
      var _this2 = this;

      e.preventDefault();
      e.stopPropagation();

      if (this.content.hasClass(CLASS_MODAL_OPEN)) return this.onClickOutside(e);
      this.content.addClass(CLASS_MODAL_OPEN);
      (0, _jquery2.default)(document).on('click', function (e) {
        return _this2.onClickOutside(e);
      });
    }
  }, {
    key: 'onClickOutside',
    value: function onClickOutside(e) {
      var _this3 = this;

      var click = this.content.find(e.target);
      if (click.length) return; //Click inside modal
      this.content.removeClass(CLASS_MODAL_OPEN);
      (0, _jquery2.default)(document).off('click', function (e) {
        return _this3.onClickOutside(e);
      });
    }
  }]);
  return InfoModal;
}();